import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { signUpInit } from '../../modules/signup';

const SignupCompleteContainer = () => {
  const manager = useSelector((state) => state.manager);
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = manager;

  const handleClick = () => {
    dispatch(signUpInit());
    history.replace('/robot');
  };

  return (
    <Grid container spacing={3} maxWidth="sm" sx={{ margin: '24px auto' }}>
      <Grid item xs={12}>
        <Typography variant="h5">
          {user.nickName}님 가입이 완료되었습니다.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button color="secondary" variant="contained" onClick={handleClick}>
          로봇 관리로 이동
        </Button>
      </Grid>
    </Grid>
  );
};

export default SignupCompleteContainer;
